<template>
  <div
    class="basic_rich_text_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
  >
    <div class="tooptipPart module_edit_btn">
      <template v-if="isHover">
        <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
        <my_hover_btn
          :tips="$t('widgets_basic_article_classification_edit_330')"
          btnIcon="el-icon-magic-stick"
          @changeStyle="changeStyle('animation')"
          v-if="this.$store.state.app.view_pattern === 'pc'"
        ></my_hover_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"
                      v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <div class="content_detail" :style="listArr.moduleStyle===2 ? 'padding: 0' : ''">
      <div
        class="rich_img_wrap animationBox"
        :title="listArr.desc"
        ref="animationBox"
        :class="{rich_img_right: listArr.moduleStyle === 1}"
        v-if="listArr.moduleStyle !== 2"
        :style="`width: ${widgets_infor.imgWidth}%;`"
        data-comb-dom
        @mouseenter="(e) => { this.mouseEnter(e) }"
        @mouseleave="(e) => { this.mouseLeave(e) }"
      >
        <div
          class="tooptipPart"
          v-show="imgHover"
          style="top: inherit; bottom: 0;"
          v-if="$store.state.app.view_pattern === 'pc'"
        >
          <my_hover_btn :tips="$t('widgets_basic_banner_index_439')" btnIcon="el-icon-edit" @changeStyle="change_img"></my_hover_btn>
        </div>
        <set_link class="linkPart" :sendData="module.data.listArr.link"></set_link>
        <img class="animationImg" :src="listArr.imgURL"/>
      </div>
      <div
        class="rich_content_wrap"
        @mouseenter="() => { this.richHover = true }"
        @mouseleave="() => { this.richHover = false }"
        data-comb-dom
      >
        <div style="position: relative;overflow: hidden;min-height: 30px;">
          <div
            class="tooptipPart"
            v-show="richHover"
            :style="textEditBtnStyle"
            v-if="$store.state.app.view_pattern === 'pc'"
          >
            <my_hover_btn :tips="$t('widgets_basic_rich_text_index_2813')" btnIcon="el-icon-edit" @changeStyle="change_rich"></my_hover_btn>
          </div>
          <div v-html="listArr.richText"></div>
        </div>
      </div>
    </div>
    <my_rich_dialog :visible.sync="richVisible" v-if="richVisible" :richText.sync="listArr.richText"></my_rich_dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_rich_text_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    widgets_infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    img_effects() {
      return this.module.data.img_effects
    },
    textEditBtnStyle() {
      // :style="listArr.moduleStyle === 1 ? 'left: 0; bottom: -28px;' : 'right: 0;'"-->
      if (Number(this.listArr.moduleStyle) === 0) {
        // 左图右文
        return {
          left: '0px',
          bottom: 'auto',
          top: '0',
          right: 'auto!important'
        }
      } else if (Number(this.listArr.moduleStyle) === 1) {
        // 左文右图
        return {
          left: '0',
          bottom: 'auto',
          top: '0',
          right: 'auto'
        }
      } else if (Number(this.listArr.moduleStyle) === 2) {
        // 纯文字
        return {
          left: '20px',
          bottom: 'auto',
          top: '0',
          right: 'auto'
        }
      }
    }
  },
  data() {
    return {
      isHover: false,
      imgHover: false,
      richHover: true,
      richVisible: false
    }
  },
  watch: {
    'listArr.richText'() {
      setTimeout(() => {
        this.templet.tooptipPart_position($(this.$el))
      }, 10)
    },
    'listArr.moduleStyle'() {
      setTimeout(() => {
        this.templet.tooptipPart_position($(this.$el))
      }, 10)
    }
  },
  mounted() {
    this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
  },
  methods: {
    module_isHover(val) {
      this.isHover = val
    },
    mouseEnter(e) {
      this.templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern)
      this.imgHover = true
    },
    mouseLeave(e) {
      this.templet.leave_animation(this.img_effects, e.target)
      this.imgHover = false
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    change_img() {
      this.$store.commit('image_upload/set_fileType', 1)
      this.$store.commit('image_upload/set_fileLimit', 1)
      this.$store.commit("image_upload/set_showTag", true)
      this.$store.state.image_upload.imgFile = (e) => {
        this.listArr.imgURL = e[0].filePath
      }
    },
    change_rich() {
      this.richVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_rich_text_index {
  .content_detail {
    padding: 16px;
    box-sizing: border-box;
    overflow: hidden;
    min-height: 30px;

    .rich_img_wrap {
      position: relative;
      float: left;
      margin-right: 26px;
      margin-bottom: 16px;
      max-width: 100%;
      overflow: hidden;
      font-size: 0;

      &.rich_img_right {
        float: right;
        margin-right: 0;
        margin-left: 26px;
      }

      img {
        width: 100%;
      }
    }

    .rich_content_wrap {
      position: relative;
      min-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_rich_text/index.vue